import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  exportData,
  getStatisticsAction,
} from "../../Actions/StatisticsAction/StattisticsAction";
import { CiFilter } from "react-icons/ci";
import LoadingPage from "../Loading/LoadingPage";
import { FaCheck } from "react-icons/fa6";
import { RxCross1 } from "react-icons/rx";
import Modal from "../../Modal/Modal";
import SearchStatisticsModal from "../../Modal/StatisticsModal/SearchStatisticsModal";
import Pagination from "../Pagination";
import { IoFilterSharp } from "react-icons/io5";
import {  FcStatistics } from "react-icons/fc";
import { RiFileExcel2Line } from "react-icons/ri";
import { getDcotorAction } from "../../Actions/DoctorAction/DoctorAction";
import {
  getOrganAction,
  getSurgeryAction,
  getTypeSurgeryAction,
} from "../../Actions/SurgeryAction/SurgeryAction";
import { getTypeOfHeAction } from "../../Actions/SurgeryAction/TypeOfHelpAction";

const StatisticsScreen = () => {
  const inistalState = {
    from: "",
    to: "",
    branch: "",
    approve: "",
    from_surgery: "",
    to_surgery: "",
    surgery: "",
    medical: "",
  };
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const dispatch = useDispatch();
  const getStatistics = useSelector((state) => state.getStatistics);
  const { statistics, total } = getStatistics;
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [searchQueries, setSearchQueries] = useState({});
  const [searchVisibility, setSearchVisibility] = useState({});
  const [searchParam, setSearchParam] = useState(inistalState);

  const handleChangeParams = (event) => {
    const { value, name } = event.target;
    setSearchParam({
      ...searchParam,
      [name]: value,
    });
  };

  useEffect(() => {
    dispatch(getStatisticsAction(page, perPage, searchParam, searchQueries));
  }, [dispatch, perPage]);

  useEffect(() => {
    dispatch(getDcotorAction(1, ""));
    dispatch(getSurgeryAction(""));
    dispatch(getTypeSurgeryAction(""));
    dispatch(getOrganAction(""));
    dispatch(getTypeOfHeAction(""));
  }, []);

  const { doctors } = useSelector((state) => state.getDoctor);
  const { surgeries } = useSelector((state) => state.getSurgery);
  const { typeSurgeries } = useSelector((state) => state.getTypeSurgery);
  const { organs } = useSelector((state) => state.getOrgan);
  const { typeOfHelps } = useSelector((state) => state.getTypeOfHelp);

  const onPageChange = (event) => {
    setPage(event.selected);
    dispatch(
      getStatisticsAction(
        event.selected + 1,
        perPage,
        searchParam,
        searchQueries
      )
    );
  };

  useEffect(() => {
    const initialVisibilityState = {};
    statistics?.forEach((visit) => {
      visit?.follow_up_commite?.forEach((follow) => {
        initialVisibilityState[follow.type] = false;
      });
      visit?.affiars_of_surgery?.forEach((affiars) => {
        initialVisibilityState[affiars.type] = false;
      });
    });
    setSearchVisibility(initialVisibilityState);
  }, [statistics]);

  const data = [];

  statistics?.forEach((visit) => {
    data.push({ type: "code", note: visit?.patient?.patient_info?.code });
    data.push({
      type: "fullname",
      note: visit?.patient?.patient_info?.fullname,
    });
    data.push({ type: "gender", note: visit?.patient?.patient_info?.gender });
    data.push({
      type: "birth_date",
      note: visit?.patient?.patient_info?.birth_date,
    });
    data.push({ type: "hospital", note: visit?.whatsApp?.name_of_hospital });

    data.push({
      type: "doctor",
      note: visit?.follow_up_commite[0]?.doctor.map((dr) => dr).join(","),
    });
    data.push({
      type: "disease_type_specialist",
      note: visit?.follow_up_commite[0]?.disease_type_specialist
        .map((disease) => disease)
        .join(","),
    });
    data.push({
      type: "organ",
      note: visit?.follow_up_commite[0]?.organ.map((organ) => organ).join(","),
    });
    data.push({
      type: "TYP",
      note: visit?.follow_up_commite[0]?.TYP.map((TYP) => TYP).join(","),
    });
    data.push({
      type: "organ_level",
      note: visit?.follow_up_commite[0]?.organ_level
        .map((organ_level) => organ_level)
        .join(","),
    });
    data.push({
      type: "type_of_help",
      note: visit?.follow_up_commite[0]?.type_of_help
        .map((type_of_help) => type_of_help)
        .join(","),
    });

    visit?.follow_up_commite?.forEach((follow) => {
      data.push({ type: follow.type, note: follow.note });
    });
    visit?.affiars_of_surgery?.forEach((affiars) => {
      data.push({ type: affiars.type, note: affiars.note });
    });
  });

  // Transform data
  const transformedData = data.reduce((acc, { type, note }) => {
    if (!acc[type]) {
      acc[type] = [];
    }
    acc[type].push(note);
    return acc;
  }, {});

  const types = Object.keys(transformedData);

  // Handle search input change
  const handleSearchChange = (e, type) => {
    setSearchQueries({ ...searchQueries, [type]: e.target.value });
  };

  // Toggle search input visibility
  const toggleSearchVisibility = (type) => {
    setSearchVisibility({
      ...searchVisibility,
      [type]: !searchVisibility[type],
    });
  };

  // Handle clearing search query for a type
  const handleClearSearch = (type) => {
    setSearchQueries({ ...searchQueries, [type]: "" });
    dispatch(
      getStatisticsAction(page, perPage, searchParam, {
        ...searchQueries,
        [type]: "",
      })
    );
  };

  const filteredData = types.reduce((acc, type) => {
    acc[type] = transformedData[type];
    return acc;
  }, {});
  const filteredMaxNotesLength = Math.min(
    ...Object.values(filteredData).map((notes) => notes.length)
  );

  const handleSearch = () => {
    dispatch(getStatisticsAction(page, perPage, searchParam, searchQueries));
  };

/*************  ✨ Windsurf Command ⭐  *************/
/**
 * Clears all search queries and parameters, resets pagination to the first page,
 * and dispatches an action to fetch statistics with the initial state and no filters.
 */

/*******  04996dd2-d311-4a1b-846e-5081f65dfa42  *******/
  const handleClearAll = () => {
    setSearchQueries({});
    setSearchParam(inistalState);
    setPage(0);
    dispatch(getStatisticsAction(page, perPage, inistalState, {})); // Pass empty object to clear all filters
  };

  const handleExport = () => {
    dispatch(exportData(searchParam.from,searchParam.to));
  };

  const { loading } = useSelector((state) => state.excelReducer);
  // console.log(filteredMaxNotesLength);
  return (
    <>
      {!statistics || statistics == undefined ? (
        <LoadingPage />
      ) : (
        <div className="parent w-[98%]">
          <div className="w-full flex justify-between items-center">
            <div className="font-bold ml-2 flex gap-2 items-center">
              <p>
                <FcStatistics />
              </p>
              Statistics
            </div>
            <div className="flex gap-2 p-2">
              <button
                className="btn-blue mb-0 my-1"
                onClick={() => setIsOpenModal(true)}
              >
                Filter <IoFilterSharp />
              </button>
              <button
                disabled={loading}
                className={
                  loading
                    ? "btn-green mb-0 my-1 opacity-50 cursor-not-allowed duration-500"
                    : "btn-green duration-500 mb-0 my-1"
                }
                onClick={handleExport}
              >
                Export <RiFileExcel2Line />
              </button>
            </div>
          </div>
          <div
            className={
              filteredMaxNotesLength === Infinity
                ? "w-[100%]"
                : "w-[100%] overflow-y-auto h-[80%]"
            }
          >
            <table
              className={
                filteredMaxNotesLength === Infinity
                  ? `bg-white border overflow-x-auto w-[50rem]  border-gray-200`
                  : "w-[300rem]"
              }
            >
              <TableHead
                typeOfHelps={typeOfHelps}
                doctors={doctors}
                surgeries={surgeries}
                typeSurgeries={typeSurgeries}
                types={types}
                organs={organs}
                searchVisibility={searchVisibility}
                handleSearch={handleSearch}
                handleSearchChange={handleSearchChange}
                toggleSearchVisibility={toggleSearchVisibility}
                searchQueries={searchQueries}
                handleClearSearch={handleClearSearch}
                statistics={statistics}
              />
              <Tbody
                statistics={statistics}
                filteredData={filteredData}
                handleClearAll={handleClearAll}
                types={types}
              />
            </table>
          </div>
          {total > 0 ? (
            <Pagination
              total={total}
              perPage={perPage}
              setPerPage={setPerPage}
              page={page}
              onPageChange={onPageChange}
            />
          ) : (
            ""
          )}
        </div>
      )}
      <Modal
        width={"w-5/12"}
        isOpen={isOpenModal}
        closeModal={() => setIsOpenModal(false)}
      >
        <SearchStatisticsModal
          onClose={() => setIsOpenModal(false)}
          searchParam={searchParam}
          handleChangeParams={handleChangeParams}
          handleSearch={handleSearch}
        />
      </Modal>
    </>
  );
};
const TableHead = ({
  searchVisibility,
  handleSearch,
  handleSearchChange,
  toggleSearchVisibility,
  searchQueries,
  handleClearSearch,
  doctors = [],
  surgeries = [],
  typeSurgeries = [],
  organs = [],
  typeOfHelps = [],
  statistics = [],
}) => {
  let allTypes = new Set();
  statistics?.forEach((item) => {
    allTypes.add("#");

    allTypes.add("code");
    allTypes.add("fullname");
    allTypes.add("gender");
    allTypes.add("birth_date");
    allTypes.add("doctor");
    allTypes.add("type_of_help");
    allTypes.add("disease_type_specialist");
    allTypes.add("organ_level");
    allTypes.add("organ");
    allTypes.add("TYP");
    // Add types from affiars_of_surgery
    item.affiars_of_surgery.forEach((subItem) => {
      allTypes.add(subItem.type);
    });

    // Add types from follow_up_commite
    item.follow_up_commite.forEach((subItem) => {
      allTypes.add(subItem.type);
    });
  });

  const types = Array.from(allTypes); // Now contains all unique types

  return (
    <thead className="bg-zinc-900 text-gray-100">
      <tr>
        {types.map((type, index) => (
          <th
            key={index}
            className="text-left relative text-gray-100 p-1 border" // Make sure the parent is positioned
            onClick={(e) => {
              e.stopPropagation(); // Prevent the click event from propagating to the th element
              toggleSearchVisibility(type);
            }}
          >
            <div className="flex items-center justify-between gap-2 cursor-pointer">
              <p>{type}</p>
              <p
                className={`${
                  searchQueries[type] ? "bg-blue-400" : "bg-slate-950"
                } text-zinc-100 p-1.5 rounded-md shadow-md`}
              >
                <CiFilter className="text-xl" />
              </p>
            </div>

            {searchVisibility[type] && (
              <div
                className="mt-2 bg-slate-300 rounded-md p-3 absolute"
                onClick={(e) => e.stopPropagation()} // Stop the click event within the modal
              >
                {/* Dynamic Filters for different types */}
                {type === "gender" ? (
                  <select
                    className="input mt-1 w-full text-black"
                    onChange={(e) => handleSearchChange(e, type)}
                    value={searchQueries[type] || ""}
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                ) : type === "doctor" ? (
                  <select
                    className="input mt-1 w-full text-black"
                    onChange={(e) => handleSearchChange(e, type)}
                    value={searchQueries[type] || ""}
                  >
                    <option value="">Select Doctors</option>
                    {doctors?.map((doctor) => (
                      <option key={doctor.name} value={doctor.name}>
                        {doctor.name}
                      </option>
                    ))}
                  </select>
                ) : type === "type_of_help" ? (
                  <select
                    className="input mt-1 w-full text-black"
                    onChange={(e) => handleSearchChange(e, type)}
                    value={searchQueries[type] || ""}
                  >
                    <option value="">Select Type Of Help</option>
                    {typeOfHelps?.map((help) => (
                      <option key={help.name} value={help.name}>
                        {help.name}
                      </option>
                    ))}
                  </select>
                ) : type === "disease_type_specialist" ? (
                  <select
                    className="input mt-1 w-full text-black"
                    onChange={(e) => handleSearchChange(e, type)}
                    value={searchQueries[type] || ""}
                  >
                    <option value="">Select Surgeries</option>
                    {surgeries?.map((surgery) => (
                      <option key={surgery.name} value={surgery.name}>
                        {surgery.name}
                      </option>
                    ))}
                  </select>
                ) : type === "organ_level" ? (
                  <select
                    className="input mt-1 w-full text-black"
                    onChange={(e) => handleSearchChange(e, type)}
                    value={searchQueries[type] || ""}
                  >
                    <option value="">Select Organ Level</option>
                    {organs?.map((organ) => (
                      <option key={organ.en_name} value={organ.en_name}>
                        {organ.en_name}
                      </option>
                    ))}
                  </select>
                ) : type === "organ" ? (
                  <select
                    className="input mt-1 w-full text-black"
                    onChange={(e) => handleSearchChange(e, type)}
                    value={searchQueries[type] || ""}
                  >
                    <option value="">Select Organ</option>
                    {typeSurgeries?.map((surgery) => (
                      <option key={surgery.name} value={surgery.name}>
                        {surgery.name}
                      </option>
                    ))}
                  </select>
                ) : type === "TYP" ? (
                  <select
                    className="input mt-1 w-full text-black"
                    onChange={(e) => handleSearchChange(e, type)}
                    value={searchQueries[type] || ""}
                  >
                    <option value="">Select TYP</option>
                    {organs?.map((surgery) => (
                      <option key={surgery.ku_name} value={surgery.ku_name}>
                        {surgery.ku_name}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    type="text"
                    value={searchQueries[type] || ""}
                    onChange={(e) => handleSearchChange(e, type)}
                    className="input mt-1 w-full text-black"
                    placeholder={`Search ${type}`}
                  />
                )}

                <div className="flex items-center gap-2 mt-1">
                  <button className="btn-green" onClick={handleSearch}>
                    <FaCheck />
                  </button>
                  <button
                    className="btn-red"
                    onClick={() => handleClearSearch(type)}
                  >
                    <RxCross1 />
                  </button>
                </div>
              </div>
            )}
          </th>
        ))}
      </tr>
    </thead>
  );
};

const Tbody = ({ statistics, handleClearAll }) => {
  let allTypes = new Set();
  statistics?.forEach((item) => {
    item.affiars_of_surgery.forEach((subItem) => {
      allTypes.add(subItem.type); 
    });

    item.follow_up_commite.forEach((subItem) => {
      allTypes.add(subItem.type); 
    });
  });

  const types = [...allTypes];

  return (
    <tbody>
      {statistics?.length <= 0 ? (
        <tr>
          <td colSpan={12} className="text-center">
            <button
              onClick={handleClearAll}
              className="bg-red-600 rounded-md shadow-md w-full  px-4 py-2  hover:bg-red-700 duration-500 text-center text-gray-100"
            >
              <p className="pt-1 ">Clear All Filter </p>
            </button>
          </td>
        </tr>
      ) : (
        statistics?.map((item, index) => (
          <tr key={index}>
            {/* Static patient info columns */}
          <td>{index+1}</td>
            <td>{item.patient.patient_info?.code}</td>
            <td>{item.patient.patient_info?.fullname}</td>
            <td>{item.patient.patient_info?.gender}</td>
            <td>{item.patient.patient_info?.birth_date}</td>
            <td>{item.follow_up_commite[0]?.doctor}</td>
            <td>{item.follow_up_commite[0]?.type_of_help}</td>
            <td>{item.follow_up_commite[0]?.disease_type_specialist}</td>
            <td>{item.follow_up_commite[0]?.organ_level}</td>
            <td>{item.follow_up_commite[0]?.organ}</td>
            <td>{item.follow_up_commite[0]?.TYP}</td>


            {types.map((type) => {
              const surgery = item.affiars_of_surgery.find(
                (surgeryItem) => surgeryItem.type === type
              );
              const followUp = item.follow_up_commite.find(
                (followUpItem) => followUpItem.type === type
              );

              const note = surgery?.note || followUp?.note || "";
           

              return (
                <td key={type} className="px-4 py-2 text-center">
                  {note}
                  {/* {doctors && <p>{doctors}</p>} */}
                </td>
              );
            })}
          </tr>
        ))
      )}
    </tbody>
  );
};

// export default Tbody;

export default StatisticsScreen;
